import React, { useEffect, useState } from "react";
import Service from "../../Services/service";
import { Link } from "react-router-dom";
import { ScheduleListHooks } from "../../Helper/ScheduleHelper";
import { hasCreatePermission, hasdeletePermission, hasEditPermission, hasSharePermission } from "../../Utils/PermissionUtils";
import ShareModal from '../../Utils/ShareModal';
import { toast } from 'react-toastify';
import service from '../../Services/service';
import DeleteModal from '../../Utils/DeleteModal';


function ScheduleListComponent() {
    const [Schedules, SetSchedules] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [sortBy, setSortBy] = useState("Name");
    const [sortDescending, setSortDescending] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [totalitems, setTotalitems] = useState(0);
    const [loading, setLoading] = useState(false);

    const canEditSchedule = hasEditPermission('Schedule');
    const canDeleteSchedule = hasdeletePermission('Schedule');
    const canShareLayout = hasSharePermission('Schedule');

    const [showModal, setShowModal] = useState(false);
    const [selectedScreenName, setSelectedScreenName] = useState('');
    const [selectedrowId, setSelectedRowId] = useState(0);

    const [deleteId, setDeleteId] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    useEffect(() => {
        getData(searchTerm, sortBy, sortDescending, pageNumber, pageSize);
    }, [searchTerm, sortBy, sortDescending, pageNumber, pageSize]);

    async function getData(
        searchTerm,
        sortBy,
        sortDescending,
        pageNumber,
        pageSize
    ) {
        setLoading(true);
        const data = await ScheduleListHooks(
            searchTerm,
            sortBy,
            sortDescending,
            pageNumber,
            pageSize
        );
        if (data) {
            SetSchedules(data.items);
            setTotalPages(data.totalPages);
            setTotalitems(data.totalItems);
            setLoading(false);
        }
    }

    const handleSortChange = (event) => {
        const [field, order] = event.target.value.split("_");
        setSortBy(field);
        setSortDescending(order === "desc");
    };

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setPageNumber(newPage);
        }
    };

    const handleDeleteClick = (id) => {
        setDeleteId(id);
        setShowDeleteModal(true);
    };

    const handleConfirmDelete = async () => {
        try {
            const response = await service.getdata("Schedule/DeleteById?id=" + deleteId);
            if (response !== undefined) {
                toast.success('Campaign Deleted successfully!');
                // Replace below with your actual refresh logic
                getData(searchTerm, sortBy, sortDescending, pageNumber, pageSize);
            }
        } catch (error) {
            toast.error('Error deleting Campaign. Please try again.');
        } finally {
            setShowDeleteModal(false);
        }
    };

    function formatDateTime(dateTimeString) {
        const options = {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            // hour: "2-digit",
            // minute: "2-digit",
            // hour12: true,
        };
        return new Date(dateTimeString).toLocaleDateString("en-IN", options);
    }

    return (
        <div>
            <div class="container-fluid content-top-gap">
                <nav aria-label="breadcrumb" class="mb-4">
                    <ol class="breadcrumb my-breadcrumb">
                        <li class="breadcrumb-item">
                            <a href="/">Home</a>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">
                            Schedule List
                        </li>
                    </ol>
                </nav>
                <div class="accordions">
                    <div class="row">
                        <div class="col-lg-12 mb-4">
                            <div class="card card_border">

                                <div className="card-header chart-grid__header d-flex justify-content-between align-items-center">
                                    <h5 className="mb-0">Schedule List</h5>
                                    {hasCreatePermission('Schedule') && (
                                        <Link to="/schedule/CreateSchedule" className="btn btn-outline-primary btn-sm">
                                            Add Schedule
                                        </Link>
                                    )}
                                </div>
                                <div class="card-body">

                                    <div className="row mb-3">
                                        <div className="col-md-4 ">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Search by name..."
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                            />{" "}
                                        </div>
                                        <div className="col-md-4 mt-2 mt-md-0">
                                            <select
                                                className="custom-select"
                                                onChange={handleSortChange}
                                                value={`${sortBy}_${sortDescending ? 'desc' : 'asc'}`}
                                            >
                                                <option value="Name_asc">Name (A-Z)</option>
                                                <option value="Name_desc">Name (Z-A)</option>
                                                <option value="CreatedAt_asc">Created At (Oldest)</option>
                                                <option value="CreatedAt_desc">Created At (Newest)</option>
                                                <option value="UpdatedAt_asc">Updated At (Oldest)</option>
                                                <option value="UpdatedAt_desc">Updated At (Newest)</option>
                                                <option value="CreatedBy_asc">Created By (A-Z)</option>
                                                <option value="CreatedBy_desc">Created By (Z-A)</option>
                                            </select>
                                        </div>
                                        <div className="col-md-4 mt-2 mt-md-0">
                                            <select
                                                className="custom-select"
                                                value={pageSize}
                                                onChange={(e) => {
                                                    setPageSize(Number(e.target.value));
                                                    setPageNumber(1); // reset to page 1
                                                }}
                                            >
                                                <option value={10}>Show 10</option>
                                                <option value={20}>Show 20</option>
                                                <option value={50}>Show 50</option>
                                                <option value={100}>Show 100</option>
                                            </select>
                                        </div>
                                    </div>
                                    {loading ? (
                                        <div className="text-center">
                                            <div className="spinner-border" role="status">
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                        </div>
                                    ) : (
                                        <table className="table table-striped table-bordered table-hover" style={{ fontSize: '14px' }}>
                                            <thead className="thead-dark">
                                                <tr>
                                                    <th>S No.</th>
                                                    <th>Event Name</th>
                                                    <th>Layout Name / Campaign Name</th>
                                                    <th>Screen Name / Screen Group</th>
                                                    <th>Priority</th>
                                                    <th>Recurrence</th>
                                                    <th>Start Date</th>
                                                    <th> End Date</th>
                                                    <th>Start Time</th>
                                                    <th>End Time</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Schedules.map((schedule, index) => (
                                                    <tr key={schedule.scheduleId}>
                                                        <td>{index + 1}</td>
                                                        <td>{schedule.eventName}</td>
                                                        <td>{schedule.layoutName} {schedule.campaignName}</td>
                                                        <td>{schedule.screenName} {schedule.screenGroupName}</td>
                                                        <td>{schedule.priorityValue}</td>
                                                        <td>{schedule.recurrence}</td>
                                                        <td>{formatDateTime(schedule.startTime)}</td>
                                                        <td>{formatDateTime(schedule.recurrenceEndDate)}</td>
                                                        <td>{schedule.startClockTime}</td>
                                                        <td>{schedule.endClockTime}</td>
                                                        {/* <td>{formatDateTime(schedule.startTime)}</td>
                                                        <td>{formatDateTime(schedule.endTime)}</td> */}
                                                        <td>
                                                            <div className="btn-group" role="group">
                                                                {canEditSchedule && (
                                                                    <>
                                                                        <Link to={"/EditSchedule/" + schedule.scheduleId} className="btn btn-outline-info btn-sm" title="Edit Layout">
                                                                            Edit
                                                                        </Link>

                                                                    </>
                                                                )}

                                                                {canDeleteSchedule && (
                                                                    <Link to="#" className="btn btn-outline-danger btn-sm" title="Delete Layout" onClick={() => handleDeleteClick(schedule.scheduleId)} >
                                                                        Delete
                                                                    </Link>
                                                                )}

                                                                {
                                                                    canShareLayout && (
                                                                        <Link
                                                                            className="btn btn-outline-success btn-sm"
                                                                            title="Share"
                                                                            onClick={() => {
                                                                                setSelectedScreenName(schedule.eventName);
                                                                                setShowModal(true);
                                                                                setSelectedRowId(schedule.scheduleId);
                                                                            }}
                                                                        >
                                                                            Share
                                                                        </Link>
                                                                    )
                                                                }
                                                            </div>
                                                        </td>

                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    )}
                                    <div className="text-center">
                                        <button
                                            className="btn btn-outline-primary btn-sm mx-2"
                                            onClick={() => handlePageChange(pageNumber - 1)}
                                            disabled={pageNumber === 1}
                                        >
                                            Previous
                                        </button>{" "}
                                        <span>
                                            Page {pageNumber} of {totalPages}{" "}
                                        </span>
                                        <button
                                            className="btn btn-outline-primary btn-sm mx-2"
                                            onClick={() => handlePageChange(pageNumber + 1)}
                                            disabled={pageNumber === totalPages}
                                        >
                                            Next
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ShareModal
                show={showModal}
                handleClose={() => setShowModal(false)}
                screenName={selectedScreenName}
                moduleId={5}
                rowId={selectedrowId}
            />
            <DeleteModal
                show={showDeleteModal}
                handleClose={() => setShowDeleteModal(false)}
                handleConfirm={handleConfirmDelete}
                message="Are you sure you want to delete this Schedule?"
            />
        </div>
    );
}

export default ScheduleListComponent;
